import api from '@motionelements/core/src/api/base-api-v2.js';
import { snakeCaseKeys } from '@motionelements/core/src/helpers/string.js';

/** Sparse fieldset for category topic cards (list by category). */
const LIST_DLPS_BY_CATEGORY_FIELDS = 'id,url,heading,subheading';

export const listDlpsByCategory = async (categoryId, params = {}) => api.get('/v2/discovery-pages', {
  params: {
    ...api.getLocaleParams(),
    ...snakeCaseKeys({
      category: categoryId,
      perPage: 10,
      sort: 'latest',
      ...params,
    }),
    'fields[page]': LIST_DLPS_BY_CATEGORY_FIELDS,
  },
});

export const getDynamicPage = async (id, params) => {
  params = params || {};
  return api.get(`/v2/discovery-pages/${id}`, {
    params: {
      ...api.getLocaleParams(),
      ...snakeCaseKeys(params),
    },
  });
};
